import { useTranslation } from 'react-i18next';

import { TONE_CLASS, TONE_LABEL_KEY } from './StatusCodeBadge.constants';
import type { StatusCodeBadgeProps } from './StatusCodeBadge.types';

export const StatusCodeBadge = ({ status }: StatusCodeBadgeProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'conversationDetail' });
	const label = t(TONE_LABEL_KEY[status.tone]);

	return (
		<span className="inline-flex shrink-0 items-center gap-2xs">
			<span
				className={`inline-flex items-center gap-3xs rounded-md border px-2xs py-3xs font-mono text-[11px] font-semibold leading-none tabular-nums ${TONE_CLASS[status.tone]}`}
				aria-label={`${status.code ?? '—'} ${label}`}
				title={label}
			>
				{status.code ?? '—'}
			</span>
			{status.derived && (
				<span
					className="rounded-md bg-grey-25 px-2xs py-3xs text-[10px] leading-none text-subtle"
					title={t('TOOL_CODE_DERIVED_HINT')}
				>
					{t('TOOL_CODE_DERIVED')}
				</span>
			)}
		</span>
	);
};
